import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${media.minWidth.sm} {
    flex-direction: row;
    align-items: center;
  }
  align-items: start;
  justify-content: space-between;
`;

export const $ItemTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  line-height: 19px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.newUI.defaultColors.menu};
`;

export const $ItemHighlighting = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  margin: ${spacing('xs')} 0;
  color: ${({ theme }) => theme.colors.success};
`;

export const $ItemHighlightingIcon = styled.span`
  margin-right: ${spacing('sm')};
  display: flex;
`;

export const $ItemDescription = styled.div`
  width: 100%;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  margin: ${spacing('xs')} 0;
`;

export const $ItemDistance = styled.div`
  font-weight: 700;
  ${fontStyle('sm')};
  line-height: 16px;
  margin: ${spacing('xs')} 0;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
`;

export const $ItemLogo = styled.div`
  width: ${spacing(16)};
  display: flex;
  justify-content: center;

  & img {
    max-height: ${spacing(9)};
    max-width: 100%;
  }
`;

export const $ItemPrice = styled.div<{
  $hasPrice: boolean;
  $hasPickupPointType: boolean;
}>`
  text-align: left;
  @media ${media.minWidth.sm} {
    text-align: ${({ $hasPickupPointType }) =>
      $hasPickupPointType ? 'left' : 'right'};
  }
  ${({ $hasPrice, theme }) =>
    $hasPrice
      ? `
        font-weight: ${fontWeight('semibold')};
        font-size: ${({
          $hasPickupPointType,
        }: {
          $hasPickupPointType: boolean;
        }) => ($hasPickupPointType ? '14px' : '16px')};
        line-height: 16px;
        color: ${theme.colors.primary};
        @media ${media.maxWidth.sm} {
          margin-top: unset;
          font-weight: ${fontWeight('medium')};
        }
      `
      : `
        color: ${theme.colors.paragraphTextColor};
        @media ${media.maxWidth.sm} {
          color: ${theme.colors.black};
          margin-top: ${spacing('lg')};
          font-weight: ${fontWeight('medium')};
        }
      `}
`;

export const $Item = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    ${$ItemTitle} {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const $ItemContentTextWrapper = styled.div`
  width: 80%;
  @media ${media.maxWidth.sm} {
    width: 100%;
  }
`;

export const $Button = styled(Button)`
  &&,
  &&:visited,
  &&:active,
  &&:focus {
    background: transparent;
    padding: 0;
    height: auto;
    min-height: auto;
    justify-content: flex-start;
    text-align: left;
    font-weight: ${fontWeight('normal')};
    ${fontStyle('sm')};
    line-height: 16px;
    text-decoration-line: underline;

    &&:hover {
      background: transparent;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
